import React from "react";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

import { Link as RouterLink, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";

import { Typography, Box, Stack, Paper, Button } from "@mui/material";

import Page404 from "../../pages/Page404";

import logo from "../../logo.svg";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

const RegistrationSuccess = () => {
  const { state } = useLocation();
  const { email } = state;
  
  const { t } = useTranslation();

  const {
    translate,
    auth: { user },
  } = useSelector((state) => state);

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  return (
    <>
      {" "}
      {user?.token === null || user?.token === 0 ? (
        <Page404 />
      ) : (
        <Stack sx={style}>
          <Box sx={{ textAlign: "center" }}>
            <Box mb={8} mt={2} pr={4}>
              <img src={logo} alt="SVG as an image"></img>
            </Box>
            {email !== undefined && (
              <Paper
                variant="outlined"
                sx={{ maxWidth: 550, padding: "16px", borderRadius: "10px" }}
              >
                <Typography pb={4} fontWeight="400" variant="h4" className="TypographyAlertaEmail" sx={{textAlign:"-webkit-left"}}>
                  {t("registrationSuccessfulMessage1")} {email}
                  {t("registrationSuccessfulMessage2")}
                </Typography>
                <Button
                  to="/"
                  size="large"
                  variant="contained"
                  component={RouterLink}
                  sx={{
                    textTransform:"none",
                    "&:hover": {
                      color: "#ffffff",
                    },
                    borderRadius:"4px"
                  }}
                >
                  {t("goToHome")}
                </Button>
              </Paper>
            )}
          </Box>
        </Stack>
      )}
    </>
  );
};

export default RegistrationSuccess;
